<table mat-table [dataSource]="_dataSource" class="mat-elevation-z8">
  @for (column of _displayedColumns; track $index) {
    <ng-container [matColumnDef]="column">
      @switch (column) {
        @case (selectColName) {
          <th mat-header-cell *matHeaderCellDef>
            @if (toggleAllEnabled) {
              <mat-checkbox
                [disabled]="disabled"
                (change)="$event ? toggleAllRows() : null"
                [checked]="headerChecked"
                [indeterminate]="headerIndeterminate"
              ></mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              [disabled]="disabled"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            ></mat-checkbox>
          </td>
        }
        @case (errorsColName) {}
        @default {
          <th mat-header-cell *matHeaderCellDef>
            {{ column | translate }}
          </th>
          @switch (column) {
            @case ('signedOn') {
              <td mat-cell *matCellDef="let row">
                {{ row[column] | date }}
              </td>
            }
            @case ('plannedDeparture') {
              <td mat-cell *matCellDef="let row">
                {{ row[column] | date }}
              </td>
            }
            @default {
              <td mat-cell *matCellDef="let row">
                {{ row[column] }}
              </td>
            }
          }
        }
      }
    </ng-container>
  }

  <ng-container [matColumnDef]="errorsColName">
    <td mat-footer-cell *matFooterCellDef [colSpan]="_displayedColumns.length">
      @if (_control.statusChanges | async) {
        @for (error of _control.errors | errorKeys; track error) {
          <mat-error>
            {{ error | translate }}
          </mat-error>
        }
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="_displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: _displayedColumns" (click)="toggleSelection(row)"></tr>
  <tr mat-footer-row *matFooterRowDef="[errorsColName]"></tr>
</table>
